import { render, staticRenderFns } from "./LoadingInfo.vue?vue&type=template&id=61d77a0f&scoped=true"
import script from "./LoadingInfo.vue?vue&type=script&lang=js"
export * from "./LoadingInfo.vue?vue&type=script&lang=js"
import style0 from "./LoadingInfo.vue?vue&type=style&index=0&id=61d77a0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d77a0f",
  null
  
)

export default component.exports